import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchAll(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/self/pass_subscriptions`,
          qs: {
            token: person,
            conditions: { event_bucket: config.event_bucket }
          }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.pass_subscriptions);
        }
      );
    });
  },

  fetchOne(person, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `pass_subscriptions/${id}`,
          qs: { token: person }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(id, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `pass_subscriptions/${id}`,
          json: values
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PassSubscriptionUtil.js